import * as yup from "yup";

import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedSnackbar,
	LabelPosition,
	RHookFormTextFieldWithLabel,
	SingleColumnLayout,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import {
	CLIENT_SETUP_SCREEN_SLUG,
	INITIAL_SNACKBAR_DATA,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	IGetListRequest,
	IResponse,
	IServerError,
} from "../../../../models/common";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { accountTypeDDL, formatDate, scrollPanelFieldsToTop, sortDDLByLabel, useNavigateToLogout } from "../../../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AccountantService } from "../../../../services";
import { BasicSetupFormToolbar } from "../../../BasicSetupFormToolbar";
import { CityService } from "../../../../services/CityService";
import { CountryService } from "../../../../services/common/CountryService";
import { GeneralSettingsService } from "../../../../services/GeneralSettingsService";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IRoles } from "../../../../models";
import { RolesPermissionsDataTable } from "./Panles/RolesPermissionsDataTable/RolesPermissionsDataTable";
import { RolesRightsDataTable } from "./Panles/RolesRightsDataTable/RolesRightsDataTable";
import { RolesService } from "../../../../services/RoleManagementServices/RolesService";
import { RolesSetupToolbar } from "./RolesSetupToolbar";
import { RolesSetupValidationSchema } from "./validator";
import { setSelectedActivityLogActions } from "../../../../store/actions/activityLogActions";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IRolesSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "roles-single-data-record";
const SINGLE_RECORD_DATA_QUERY_KEY_BY_ID = "roles-single-data-record-by-id";

const useGetData = (
	// isOwner: boolean | number,
	accountType: number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, accountType, navigateToLogout],
		queryFn: (data) => {
			return RolesService.getRolesRightsAndPermissionsDefaultScreenLoadData(accountType, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetDataById = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY_BY_ID, id, navigateToLogout],
		queryFn: (data) => {
			return RolesService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetRolesDDL = () =>
	useQuery({
		queryKey: ["roles-ddl"],
		queryFn: (data) => {
			return RolesService.getRolesDDL();
		},
		refetchOnWindowFocus: false,
	});

export const RolesSetup: React.FC<IRolesSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const theme = useTheme();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const assignedRolesToUsers = useSelector(
		(state: IAppState) => state.user.profile.roleId
	);



	const isPendingActivityLogData = useSelector(
		(state: IAppState) => state.isLoadAxiosCall.isLoading
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [isPendingData, setIsPendingData] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [rolesId, setRolesId] = useState<any>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [provinceStateDDLinUpdate, setProvinceStateDDLinUpdate] =
		useState(undefined);
	const [cityDDLinUpdate, setCityDDLinUpdate] = useState(undefined);
	const [provinceStateLabelinUpdate, setProvinceStateLabelinUpdate] =
		useState<any>(undefined);
	const queryRoles = useQueryClient();
	const { id } = useParams();

	const [rolesRightsUpdatedData, setRolesRightsUpdatedData] = useState<any>(undefined);
	const [rolesPermissionsUpdatedData, setRolesPermissionsUpdatedData] = useState(undefined);
	const [roleRightsAndPermissionsInitialAndSavedData, setRoleRightsAndPermissionsInitialAndSavedData] = useState<any>(undefined);
	const [editRecordId, setEditRecordId] = useState(id);
	// const [isOwnerScreens, setIsOwnerScreens] = useState(false)
	const [accountType, setAccountType] = useState(200)

	useEffect(() => {
		if (id) {
			setEditRecordId(id)
		}
	}, [id])

	let assignedRolesIds = assignedRolesToUsers.map((x: any) => x.roleId)
	let isSelectedRoleAssinged = id && assignedRolesIds.includes(id)

	const { isPending: isSubmitting, mutate: submitFormFields } = useMutation({
		mutationFn: RolesService.create,
		onSuccess: (res: IRoles | IServerError | IResponse | any) => {


			if (res && res.status === 201 || res && res.status === 200) {
				setEditRecordId(res.id);
				queryRoles.invalidateQueries({
					queryKey: ["roles-ddl"],
				});
				queryRoles.invalidateQueries({
					queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
				});
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				scrollPanelFieldsToTop();

				// call general settings to dave default settings 
				// (async () => {
				// 	let payload = {
				// 		rolesId: res.data.id,
				// 		navigateToLogout: navigateToLogout,
				// 		repeatColumnHeading: 200,
				// 		timeFormat: 200,
				// 		employeeId: 300,
				// 		allEmployeesPaymentMethod: undefined,
				// 		vacationPayonPaidVacPay: 100,
				// 		payrollRemittancesMethod: 200,
				// 		vacationPayOnPaidVacPay: 100,
				// 		vacationPay: 200,
				// 		payoutVacationpay: 100,
				// 		commission: 100,
				// 		overtimeHours: 300,
				// 		edrFields: 200,
				// 		bonus: 200,
				// 		nonPeriodicPayment: 200,
				// 		retroactivePayIncrease: 200,
				// 		employeeSelectionInPayroll: 100,
				// 		hourlyPayRate: 100,
				// 		companyLogo: null,
				// 	};
				// 	try {
				// 		const response: any =
				// 			await GeneralSettingsService.create(
				// 				payload
				// 			);
				// 	} catch { }
				// })();
				let path = `/role-management/role/setup/${res.data.id}`;
				navigate(path);
			} else if (res && res.message === "Success") {
				setSnackbarData({
					open: true,
					message: res.message,
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { isPending: isPendingDataById, data: rolesRightsAndPermissionsDataById } = useGetDataById(
		editRecordId,
		navigateToLogout
	);
	const { isPending: isPendingById, data: rolesRightsAndPermissions } = useGetData(
		accountType,
		navigateToLogout
	);

	let rolesRightsAndPermissionsData: any = rolesRightsAndPermissions;


	const buildScreensFromRoles = (data: any) => {
		return {
			screens: data.map(({ screenId, screenName, url, ...permissions }: any) => {
				const screenObj: any = {
					screenId,
					screenName: screenName.trim(),
					url: url,
				};

				Object.entries(permissions).forEach(([key, value]: any) => {
					if (value?.type === "switch") {
						screenObj[key] = false;
					} else if (value?.type === "list") {
						screenObj[key] = null;
					}
				});

				return screenObj;
			}),
		};
	};

	useEffect(() => {
		setIsPendingData(true)
		// if (rolesRightsAndPermissionsData && !rolesRightsAndPermissionsData.message && !id) {
		// 	alert(1)
		// 	const initialData = buildScreensFromRoles(rolesRightsAndPermissionsData.items)
		// 	setRoleRightsAndPermissionsInitialAndSavedData(initialData)

		// } else if (id && accountType === 200 && rolesRightsAndPermissionsData && !rolesRightsAndPermissionsData.message) {
		// 	alert(2)
		// 	const initialData = buildScreensFromRoles(rolesRightsAndPermissionsData.items)
		// 	setRoleRightsAndPermissionsInitialAndSavedData(initialData)
		// } else if (id && accountType !== 200 && rolesRightsAndPermissionsDataById) {
		// 	alert(3)
		// 	setRoleRightsAndPermissionsInitialAndSavedData(rolesRightsAndPermissionsDataById)
		// }else {
		// 	alert(4)
		// }
		if (rolesRightsAndPermissionsData && !rolesRightsAndPermissionsData.message && !id) {
			const initialData = buildScreensFromRoles(rolesRightsAndPermissionsData.items)
			setRoleRightsAndPermissionsInitialAndSavedData(initialData)
		} else if (id && rolesRightsAndPermissionsDataById && accountType === rolesRightsAndPermissionsDataById.accountType && rolesRightsAndPermissionsData && !rolesRightsAndPermissionsData.message) {
			const initialData = buildScreensFromRoles(rolesRightsAndPermissionsData.items)

			const mergedInitialAndDataByIdScreens = [
				...rolesRightsAndPermissionsDataById.screens,
				...initialData.screens.filter(
					(s1: any) =>
						!rolesRightsAndPermissionsDataById.screens.some(
							(s2: any) => s2.screenName === s1.screenName
						)
				)
			];

			rolesRightsAndPermissionsDataById.screens = mergedInitialAndDataByIdScreens;
			setRoleRightsAndPermissionsInitialAndSavedData(rolesRightsAndPermissionsDataById)
		} else if (id && rolesRightsAndPermissionsData && !rolesRightsAndPermissionsData.message && rolesRightsAndPermissionsDataById && accountType !== rolesRightsAndPermissionsDataById.accountType) {
			const initialData = buildScreensFromRoles(rolesRightsAndPermissionsData.items)
			setRoleRightsAndPermissionsInitialAndSavedData(initialData)
		}
		setIsPendingData(false)
	}, [rolesRightsAndPermissionsData, accountType, rolesRightsAndPermissionsDataById, id])

	const { isPending: isPendingRolesDDL, data: rolesDDL } =
		useGetRolesDDL();
	console.log("ffff", rolesDDL)
	const rolesDDLItems = useMemo(() => {
		if (rolesDDL && rolesDDL.rolesData && Array.isArray(rolesDDL.rolesData)) {
			let roles: IDropDownListResponse[] = sortDDLByLabel(rolesDDL.rolesData).map(
				(rolesItem: IDropDownListResponse) => ({
					id: rolesItem.id,
					label: rolesItem.label,
					value: rolesItem.value,
				})
			);
			if (isAdminUser === 400) {
				roles.unshift({
					label: "Create New",
					value: "create-new",
				});
			}
			return roles;
		}

		if (isAdminUser === 400) {
			return [
				{
					label: "Create New",
					value: "create-new",
				},
			];
		} else {
			return []
		}
	}, [rolesDDL]);

	const DEFAULT_VALUES = {

	};

	const ExtendedValidationSchema = RolesSetupValidationSchema.shape({
		roleName: yup
			.string()
			.nullable()
			.test(
				"roleName-required-for-admin",
				"Role Name is required",
				function (value) {
					const { isAdminUser } = this.options.context || {};

					if (isAdminUser === 400) {
						return !!value;
					}

					return true;
				}
			),

		newRoleName: yup
			.string()
			.nullable()
			.test(
				"newRoleName-required-for-non-admin",
				"New Role Name is required",
				function (value) {
					const { isAdminUser, id } = this.options.context || {};

					if (isAdminUser !== 400 && id) {
						return !!value;
					}

					return true;
				}
			),
	});
	const formMethods = useForm<any>({
		// resolver: yupResolver(RolesSetupValidationSchema),
		resolver: yupResolver(ExtendedValidationSchema),
		context: {
			isAdminUser,
			id,
		},
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES,
	});

	const onSubmit = async (values: any) => {

		// alert(isAdminUser)
		if (isAdminUser === 400) {
			let payload = {
				id: id && id,
				roleName: values.roleName,
				newRoleName: isAdminUser !== 400 && id && values.newRoleName && values.newRoleName !== "" ? values.newRoleName : undefined,
				// accountType: values.accountType,
				accountType: accountType,
				screens: rolesRightsUpdatedData && rolesRightsUpdatedData.screens ? rolesRightsUpdatedData.screens : [],
				navigateToLogout: navigateToLogout,

			};

			submitFormFields(payload);
		} else {
			// alert(1)
			if (!id) {
				setSnackbarData({
					open: true,
					message: "Please select Role to proceed!",
					severity: "error"
				})
			} else {
				let assignedRolesIds = assignedRolesToUsers.map((x: any) => x.roleId)
				let isSelectedRoleAssinged = assignedRolesIds.includes(values.roles)

				// alert(isSelectedRoleAssinged)
				if (isSelectedRoleAssinged) {
					// this loaded role is assigned to this user
					let payload = {
						roleName: values.newRoleName,
						accountType: accountType,
						screens: rolesRightsUpdatedData && rolesRightsUpdatedData.screens ? rolesRightsUpdatedData.screens : [],
						navigateToLogout: navigateToLogout,
					};

					submitFormFields(payload);
				} else {
					// this loaded role is assigned to this user
					let payload = {
						id: id && id,
						roleName: values.updateRoleName,
						// roleName: rolesRightsAndPermissionsDataById.roleName,
						accountType: accountType,
						screens: rolesRightsUpdatedData && rolesRightsUpdatedData.screens ? rolesRightsUpdatedData.screens : [],
						navigateToLogout: navigateToLogout,
					};

					submitFormFields(payload);
				}
			}
		}

	};

	useEffect(() => {

		if (id && rolesRightsAndPermissionsDataById) {
			Object.keys(rolesRightsAndPermissionsDataById).forEach((fieldName: any) => {
				const fieldValue = rolesRightsAndPermissionsDataById[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);

				if (isAdminUser !== 400 && fieldName === 'roleName') {
					formMethods.setValue(fieldName, fieldValue);
					if (!isSelectedRoleAssinged) {
						formMethods.setValue("newRoleName", fieldValue);
					} else {
						formMethods.setValue("newRoleName", undefined);
					}
					// formMethods.setValue("updateRoleName", fieldValue);
				}
			});
			formMethods.setValue("roles", rolesRightsAndPermissionsDataById.id);
			setAccountType(rolesRightsAndPermissionsDataById.accountType)
			// setRoleRightsAndPermissionsInitialAndSavedData(rolesRightsAndPermissionsDataById)
		}
	}, [id, rolesRightsAndPermissionsDataById]);

	const onRoleSelectionChangeHandler = (item: any) => {
		setIsPendingData(true)
		const value = item.value
		if (value !== "create-new") {
			let path = `/role-management/role/setup/${value}`
			navigate(path)
			setIsPendingData(false)
		} else {
			let path = `/role-management/role/setup`
			navigate(path)
			formMethods.reset();
			formMethods.setValue("roles", "create-new");
			setAccountType(200)
			if (rolesRightsAndPermissionsData) {
				const initialData = buildScreensFromRoles(rolesRightsAndPermissionsData.items)
				setRoleRightsAndPermissionsInitialAndSavedData(initialData)
			}
			setIsPendingData(false)
		}
	}

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteRolesById } = useMutation({
		mutationFn: RolesService.delRoles,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Roles fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			// formMethods.reset();
			scrollPanelFieldsToTop();
			let path = `/roles/list`;
			navigate(path);
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteRolesField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				rolesId: rolesId,
				navigateToLogout: navigateToLogout,
			};
			deleteRolesById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (rolesRightsAndPermissionsData) {
			setRolesId(rolesRightsAndPermissionsData.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		scrollPanelFieldsToTop();
		let path = `/role-management/role/setup`;
		navigate(path);
	};

	// const { isPending, data } = useAccountants({
	//   search_query: "",
	//   order_by: "acc_title",
	//   order_direction: "asc",
	//   page: 1,
	//   size: 25,
	// });
	// const accountantList: any = data;
	// const enhanceData = (data: any[]): any[] => {
	// 	return data.map((item) => {
	// 		const enhancedItem = {
	// 			...item,
	// 			expanded: false,
	// 		};
	// 		return enhancedItem;
	// 	});
	// };
	const clientStoreId = useSelector((state: IAppState) => state.client.id);
	const expandedLabels = ["Role Management"];
	const expandedLabelsForAdmin = ["User Management"];
	const expandedHomeRolesSetupOrRolesSetupItem = "Role Setup"; // Special case for "RolesSetup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			if (clientStoreId && clientStoreId !== "") {
				let isExpanded = expandedLabelsForAdmin.includes(item.label);
				if (
					parentLabel === "Role Management" &&
					item.label === expandedHomeRolesSetupOrRolesSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedHomeRolesSetupOrRolesSetupItem && "/role-management/role/setup",
				};
				return enhancedItem;
			} else {

				let isExpanded = expandedLabels.includes(item.label);
				if (
					parentLabel === "Role Management" &&
					item.label === expandedHomeRolesSetupOrRolesSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedHomeRolesSetupOrRolesSetupItem && "/role-management/role/setup",
				};
				return enhancedItem;
			}
		});
	};
	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: id ? id : "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: CLIENT_SETUP_SCREEN_SLUG,
		// 		accountantName: rolesName,
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onIsOwnerSelectionChangeHandler = (e: any) => {
		if (accountType !== e.value) {
			setIsPendingData(true)
			setAccountType(e.value)
		}
	}

	// let roleRightsAndPermissionsSavedData = {
	// 	screens: [
	// 		{
	// 			screenId: "123123",
	// 			screen: "Client List",
	// 			view: false,
	// 			add: false,
	// 			update: false,
	// 			delete: false,
	// 			print: false,
	// 			status: ["active"],
	// 		},
	// 		{
	// 			screenId: "123123dfv",
	// 			screen: "Client Setup",
	// 			view: true,
	// 			add: true,
	// 			update: false,
	// 			delete: false,
	// 			calculate: false,
	// 			pay_period: null,
	// 		},
	// 	]
	// }

	return (
		<Grid sx={{ mt: "1.7rem" }}>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingData ||
					isPendingById ||
					isDeleting ||
					isPendingActivityLogData ||
					provinceDDLLoading ||
					isPendingRolesDDL ||
					isPendingDataById
				}
				testId="accountant Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteRolesField}
				cancelActionHandler={onCloseHandler}
				testId="accountant-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid
						container
						size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
						sx={{
							background: "#fff",
							border: "1px solid #e5e7eb",
							borderBottom: 0,
							borderRadius: "2px 2px 0 0",
							padding: "31px 20px 0 20px",
						}}
						columnSpacing={2}
					>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
							<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
								<EnhancedDropDownRHFWithLabel
									selectName="roles"
									testId={`roles-list`}
									items={rolesDDLItems ?? []}
									// showEmpty
									label="Role"
									selectedItem={isAdminUser === 400 ? "create-new" : undefined}
									onSelectionChangeHandler={onRoleSelectionChangeHandler}
								/>
							</Grid>
							<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
								{isAdminUser === 400 ? <RHookFormTextFieldWithLabel
									label="Role Name"
									id="roleName"
									testId={`roleName`}
								/> : isAdminUser !== 400 && id && <RHookFormTextFieldWithLabel
									label={!isSelectedRoleAssinged ? "Update Role Name" : "New Role Name"}
									// id="newRoleName"
									id={!isSelectedRoleAssinged ? "updateRoleName" : "newRoleName"}
									testId={`roleName`}
								/>}
							</Grid>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
							{/* <Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
								<EnhancedIOSSwitchRHFWithLabel
									name="isAdmin"
									checked={false}
									testId="isAdmin"
									label="Is Admin"
								/>
							</Grid> */}
							<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
								{/* <EnhancedIOSSwitchRHFWithLabel
									name="isAdmin"
									checked={false}
									testId="isOwner"
									label="Is Owner"
									onSelectionChangeHandler={onIsOwnerSelectionChangeHandler}
								/> */}
								{isAdminUser === 400 && <EnhancedDropDownRHFWithLabel
									label="Account Type"
									selectName="accountType"
									testId={`account-type`}
									labelPosition={LabelPosition.Top}
									items={accountTypeDDL ?? []}
									onSelectionChangeHandler={onIsOwnerSelectionChangeHandler}
									selectedItem={200}
								/>}
							</Grid>
						</Grid>
					</Grid>

					{/* <TwoColumnLayout
				toolbar={<></>}
				leftColumnContent={
					<>
						<StandardPanel
							title="ROLE RIGHTS"
							testId={`roles-info`}
							variant="outlined"
							borderHide={true}
						>
							<RolesRightsDataTable
								rolesRightsUpdatedData={(data: any) =>
									setRolesRightsUpdatedData(data)
								}
								rolesRightsDataItems={rolesRightsAndPermissionsData && rolesRightsAndPermissionsData.items}
							// rolesRightsDataItems={[]}
							/>
						</StandardPanel>
					</>
				}
				rightColumnContent={
					<>
						<StandardPanel
							title="ROLE PERMISSIONS"
							testId={`roles-address-info`}
							variant="outlined"
							borderHide={true}
						>
							<RolesPermissionsDataTable
								rolesPermissionsUpdatedData={(data: any) =>
									setRolesPermissionsUpdatedData(data)
								}
								rolesPermissionsDataItems={rolesRightsAndPermissionsData && rolesRightsAndPermissionsData.permissions.items}
								rolesPermissionsHeaderColumns={rolesRightsAndPermissionsData && rolesRightsAndPermissionsData.permissions?.headerColumns}
							// rolesRightsDataItems={[]}
							/>
						</StandardPanel>
					</>
				}
				testId="t4-slip-setup-form"
			/> */}
					<SingleColumnLayout toolbar={<></>} testId={"undefined"} showFullDiaplay={true}>
						{isAdminUser !== 400 && !id ?
							<></>
							: <StandardPanel
								title="ROLE RIGHTS / PERMISSIONS"
								testId={`roles-info`}
								variant="outlined"
								borderHide={true}
							>
								{rolesRightsAndPermissionsData && rolesRightsAndPermissionsData.message &&
									rolesRightsAndPermissionsData.message === "Unknown error" ?
									<span>
										<Link
											to={`/role-management/screen`}
											className="no-underline"
											style={{ color: theme.palette.primary.light }}
										>
											Please add screen for <span style={{ fontWeight: "bold" }}>{accountType === 200 ? "Admin" : accountType === 300 ? "Super User" : "Accountant"}</span> role to assign role rights/permissions
										</Link></span>
									: <RolesRightsDataTable
										rolesRightsUpdatedData={(data: any) =>
											setRolesRightsUpdatedData(data)
										}
										rolesRightsDataItems={rolesRightsAndPermissionsData && rolesRightsAndPermissionsData.items}
										rolesRightsAndPermissionsHeaderColumns={rolesRightsAndPermissionsData && rolesRightsAndPermissionsData.headerColumns}
										roleRightsAndPermissionsSavedData={roleRightsAndPermissionsInitialAndSavedData && roleRightsAndPermissionsInitialAndSavedData}
									// rolesRightsDataItems={[]}
									/>}
							</StandardPanel>}
					</SingleColumnLayout>
					<RolesSetupToolbar
						onResetClicked={onResetClicked}
						isSubmitting={isSubmitting}
						id={id}
						onDeleteClicked={onDeleteClicked}
					/>
				</form>
			</FormProvider>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
